import React from 'react';
import { Radio, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { VIEW_MODES, SETTINGS_KEYS } from '../../../../../configs/viewSettings';
import styles from '../config.less';

const SortType = (props) => {
  const { t } = useTranslation();

  if (!props.settings) {
    return null;
  }

  const value = props.settings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.SORT_TYPE]);
  const currentFieldId = props.settings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.FIELD_ID]) || '#id';

  const handleChange = (e) => {
    viewSettingsActions.setSortingRecords({
      catalogId: props.catalogId,
      viewId: props.viewId,
      viewMode: VIEW_MODES.CALENDAR,
      sortField: currentFieldId,
      sortType: e.target.value,
    });
  };

  return (
    <Row className={styles.controlRow} style={{ marginTop: '-6px' }}>
      <Radio.Group value={value} onChange={handleChange}>
        <Radio.Button value={1}>
          <span className={styles.radioValue}>{t('calendar.config.ascending')}</span>
        </Radio.Button>
        <Radio.Button value={-1}>
          <span className={styles.radioValue}>{t('calendar.config.descending')}</span>
        </Radio.Button>
      </Radio.Group>
    </Row>
  );
};

export default SortType;
